import { GTM_ID } from "utils/constants";

const Plugins = {
  adobe: {
    enabled: false,
    escaped_script: "window.ANALYTICS_TYPE = 'adobe';",
    js_libs: [
      {
        async: true,
        src:
          "//assets.adobedtm.com/421ede9e1bd0/f484dfb0d412/launch-70d81f754f20-staging.min.js"
      }
    ]
  },
  clevertap: {
    data: {
      notifications: {
        delay: 3000
      }
    },
    enabled: false,
    escaped_script: "window.CLEVERTAP_ACCOUNT_ID = 'TEST-758-7K7-946Z';",
    js_libs: [
      {
        async: true,
        src: "/clevertap_sw.js"
      },
      {
        async: true,
        src: "/clevertap.js"
      }
    ]
  },
  googleTagManager: {
    enabled: true,
    escaped_script: `window.GOOGLE_TAG_MANAGER_ID = '${GTM_ID}';`,
    js_libs: [
      {
        async: true,
        src: "/googleTagManager.js"
      }
    ],
    noscript: `<iframe src=https://www.googletagmanager.com/ns.html?id=${GTM_ID} height='0' width='0' style='display:none;visibility:hidden'></iframe>`
  },
  hotjar: {
    enabled: false,
    escaped_script:
      "(function (h, o, t, j, a, r) {   h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };   h._hjSettings = { hjid: 1951318, hjsv: 6 };   a = o.getElementsByTagName('head')[0];   r = o.createElement('script'); r.async = 1;   r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;   a.appendChild(r); })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');"
  },
  payment: {
    css_libs: [
      "https://sid-paymentweb.circles.life/circles-payment/circles-payment.css"
    ],
    enabled: false,
    js_libs: [
      {
        src:
          "https://sid-paymentweb.circles.life/circles-payment/circles-payment.js"
      }
    ]
  },
  zendesk: {
    data: {},
    enabled: true,

    js_libs: [
      // {
      //   id: "ze-snippet",
      //   src:
      //     `https://static.zdassets.com/ekr/snippet.js?key=${process.env.REACT_APP_ZENDESK_WIDGET_KEY}`
      // }
      {
        src: "/zendeskWidget.js"
      }
    ]
  }
};

export default Plugins;
